export default "__VITE_ASSET__ClAYi4oL__"